<template>
    <div>
        <Title title="FICHA_SAUDE.ACEITAR_TERMOS"/>
        <div class="mt-4">
            <p>Ao clicar no botão abaixo você terá acesso ao contrato:</p>
            <b-button @click="baixarContrato" variant="info" class="w-100">{{ $t('MATRICULAS.BAIXAR_CONTRATO') }}</b-button>
            <input-checkbox
            v-model="checked"
            :label="$t('MATRICULAS.ACEITO_TERMOS')"
            class="mt-2 d-flex justify-content-center"
            />
            <p class="pt-4">
                Estando de acordo, clique no aceite dos termos e em seguida 
                clique no botão "Fazer rematrícula".
                
                Caso encontre qualquer dado neste formulário que precise ser alterado,
                clique no botão "Solicitar alteração cadastral" para abrir um protocolo 
                e solicitar ajuste.
            </p>
        </div>
    </div>
</template>
<script>
import Title from "@/components/Title.vue";
import InputCheckbox from '@/components/inputs/InputCheckbox.vue';
export default {
    components: { InputCheckbox, Title },
    data(){
        return{
            checked: false
        }
    },
    watch: {
        checked(){
            this.$emit('aceitar', this.checked)
            return this.checked
        }
    },
    methods: {
        baixarContrato(){
            this.$emit('baixa-contrato')
        }
    }
}
</script>